var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.351,
    height: 21.015,
    viewBox: "0 0 22.351 21.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_52_1",
    "data-name": "Component 52 \\u2013 1",
    transform: "translate(0.509 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M3.822,20.256a.708.708,0,0,0,.995.79l5.852-3.008,5.851,3.008a.707.707,0,0,0,.995-.789L16.41,13.95l4.7-4.474a.741.741,0,0,0-.377-1.266L14.2,7.282,11.287,1.513a.684.684,0,0,0-1.236,0L7.139,7.283l-6.53.928A.741.741,0,0,0,.232,9.477l4.7,4.474L3.822,20.258Zm6.539-3.689.925-5.366-1.236,2.751h3.6c.044-.247-3.424-.635-3.6-.809L2.281,9.449l7.769,3.691c.227-.034,1.135-3.457,1.236-3.664L10.67,3.421,10.051,11.2c.1.206.391,2.717.618,2.751v-.811l.618-1.941a8.511,8.511,0,0,0-.31,1.941l4.914,5.95-4.6-7.891c-.193-.1-.732,5.267-.924,5.366Z",
    transform: "translate(-0.003 -1.122)",
    fill: "#329bc9",
    stroke: "#329bc9",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.769bb99a5aa73af444ed4e97c23c2d54.svg";
export { ForwardRef as ReactComponent };